import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {clone} from '../../../helpers/DataHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {
    cancelUsersFormDispatch,
    setDefaultUserData,
    userFormServerValidationErrors
} from '../../../pages/user/form/UserForm-Actions'
import {scrollToError} from '../../../helpers/ScrollHelper'

function _success(success) {
    return {type: 'CREATE_ORGANIZATION_USER_SUCCESS', success}
}

function _error(error) {
    return {type: 'CREATE_ORGANIZATION_USER_ERROR', error}
}

function _processing(processing) {
    return {type: 'CREATE_ORGANIZATION_USER_PROCESSING', processing}
}

function createOrganizationUser(organization_id) {
    return (dispatch, getState) => {
        let UserForm = clone(getState().organizationUserForm)
        let {organizationDashboard} = getState();
        let org_id = organization_id || organizationDashboard.data.organization_id;
        dispatch(_success(null))
        dispatch(_error(null))
        dispatch(_processing(true))

        axios({
            url: apiBaseUrl(`admin/organizations/${org_id}/customers`),
            method: 'post',
            dataType: 'json',
            data: JSON.parse(JSON.stringify(UserForm.data.payload)),
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                handleSuccess(res)
                store.dispatch(setDefaultUserData())
                store.dispatch(cancelUsersFormDispatch())

            }).catch(function (error) {
            dispatch(_error(error))
            dispatch(_processing(false))
            handleError(error)

            store.dispatch(cancelUsersFormDispatch())
            if (error.response && error.response.status === 422) {
                store.dispatch(userFormServerValidationErrors(error.response.data.errors))
                scrollToError()
            }
        })
    }
}

export default createOrganizationUser
